import type { ReactNode } from "react";
import { ActionButton } from "@hamlak/ui";

export function EmptyState({ message, action }: { message: ReactNode; action?: { label: string; onClick: () => void } }) {
  return (
    <div className="page-placeholder" role="status" style={{ flexDirection: "column", gap: 12 }}>
      <p style={{ margin: 0 }}>{message}</p>
      {action && (
        <ActionButton variant="neutralWeak" size="small" onClick={action.onClick}>
          {action.label}
        </ActionButton>
      )}
    </div>
  );
}
